export default __webpack_public_path__ + "static/titilliumweb-bold-webfont-38c2b7e37a4789b230d56971165d770c.eot";